<template>
  <BaseButton
    color="red"
    :size="isMobile || !$store.getters.isRtbFlowPossible ? 'large' : 'default'"
    class="flex items-center justify-center"
    :class="{'w-full': !$store.getters.isRtbFlowPossible}"
    :is-loading="isLoading"
    :data-test-id="dataTestId"
    @click="$emit('click')"
  >
    {{ $store.getters.cta.thirdStep }}
  </BaseButton>
</template>

<script>
import ScreenWidth from '@/components/ScreenWidth';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';
import htmlProps from '@/components/Ui/htmlProps.js';

export default {
  name: 'FinishEnquiryButton',
  emits: ['click'],
  mixins: [htmlProps, ScreenWidth],
  components: { BaseButton },
  computed: {
    isLoading() {
      return this.$store.state.isLoading.sendEnquiry;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
